export default class Plate extends Phaser.Group {
  constructor(game, scene) {
    super(game);

    this.scene = scene;
    this.plate = this.game.make.image(0, 0, 'foodgame_elements', 'plate.png');
    this.plate.anchor.set(0.5, 1);
    this.addChild(this.plate);

    this.onPosition = new Phaser.Signal();
    this.onFoodUp = new Phaser.Signal();
    this.onFoodDown = new Phaser.Signal();
    this.reset();
  }

  reset() {
    if (this.food) {
      this.food.destroy();
    }
    if (this.extra) {
      this.extra.destroy();
      this.extra = null;
    }

    // select food
    if (this.scene.getFoodType() == false) {
      // bad food
      this.isGood = false;
      let id = (1 + 4 * Math.random()) | 0;
      this.foodAtlas = 'foodgame_elements';
      this.foodKey = 'food_bad_' + id + '.png';
      this.foodKeyExtra = 'food_bad_' + id + '_extra.png';
      this.food = this.game.make.image(0, 0, this.foodAtlas, this.foodKey);
    } else {
      // good food
      this.isGood = true;
      this.foodKey = 'food_good';
      this.foodKeyExtra = 'food_good_extra';
      this.food = this.game.make.image(0, 0, this.foodKey);

      if (this.game.cache.checkImageKey(this.foodKeyExtra)) {
        this.extra = this.game.make.image(0, 0, this.foodKeyExtra);
        this.extra.anchor.set(0.5, 1);
        this.addChildAt(this.extra, 1);
      }
    }

    this.food.anchor.set(0.5, 1);
    this.addChild(this.food);

    // let gotFrame = this.food.animations._frameData.getFrameByName(this.foodKeyExtra);
    // if (gotFrame) {
    //   this.extra = this.game.make.image(0, 0, this.foodAtlas, this.foodKeyExtra);
    //   this.extra.anchor.set(0.5, 1);
    //   this.addChildAt(this.extra, 1);
    // }

    // set on left side
    this.x = -1000;
  }

  stop() {
    if (this.tween) {
      this.tween.stop();
    }
  }

  goIn() {
    this.tween = this.game.add.tween(this).to({ x: 0 }, 800, Phaser.Easing.Quadratic.Out, true);
    this.tween.onComplete.add(this.handleGoIn, this);

    this.game.sounds.playSpriteSFX('slide', { spriteID: 'game_audiosprite' });
  }

  handleGoIn() {
    this.onPosition.dispatch();
  }

  goOut() {
    this.tween = this.game.add.tween(this).to({ x: 1000 }, 800, Phaser.Easing.Quadratic.Out, true);
    this.tween.onComplete.add(this.handleGoOut, this);
  }

  handleGoOut() {
    this.reset();
  }

  throwUp() {
    if (this.isGood) {
      let tween = this.game.add.tween(this.food).to({ y: '-175' }, 200, null, true);
      tween.onComplete.add(this.handleThrowUp, this);
    } else {
      let tween = this.game.add.tween(this.food).to({ y: '-240' }, 400, null, true);
      tween.onComplete.add(this.handleThrowUp, this);
    }
  }

  handleThrowUp() {
    this.food.visible = false;
    this.onFoodUp.dispatch(this.food, this.foodAtlas, this.foodKey);
  }

  throwDown() {
    let tween = this.game.add.tween(this.food).to({ y: '+280' }, 200, null, true);
    tween.onComplete.add(this.handleThrowDown, this);
  }

  handleThrowDown() {
    this.food.visible = false;
    this.onFoodDown.dispatch();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/Plate.js